var React = require('react');

function NextInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"18","cy":"18.7158","r":"17","stroke":"white","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M16.5 13.7158L21.3148 18.289C21.5617 18.5329 21.5617 18.8987 21.3148 19.1426L16.5 23.7158","stroke":"white","strokeWidth":"1.8529","strokeMiterlimit":"10","strokeLinecap":"round","key":1})]);
}

NextInline.defaultProps = {"width":"36","height":"37","viewBox":"0 0 36 37","fill":"none"};

module.exports = NextInline;

NextInline.default = NextInline;
